export default __webpack_public_path__ + "static/ExigentCapitalLogo-64a361560bbbf9d959d0b1fb174e7a5f.jpg";